<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
<!--    <a-form-model-item label="名称">-->
<!--      <a-input v-model="form.data.name"/>-->
<!--    </a-form-model-item>-->
    <a-form-model-item label="详情">
      <a-textarea v-model="form.data.detail" style="height: 150px"/>
    </a-form-model-item>
    <a-form-model-item label="详情英文">
      <a-textarea v-model="form.data.detailEn" style="height: 150px"/>
    </a-form-model-item>
    <div style="text-align: right">
      <a-space>
        <a-button
          type="primary"
          v-if="!fqaDictDataId"
          @click="onAdd"
          :disabled="form.disabled">
          {{ $t('CREATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button
          type="primary"
          v-if="fqaDictDataId"
          @click="onUpdate"
          :disabled="form.disabled">{{ $t('UPDATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </div>
  </a-form-model>
</template>

<script>
import {
  _queryFqaDictDataById,
  _addFqaDictData,
  _updateFqaDictData,
} from '@/api/fqaDictDataApi';
// import HtmlEditor from '@/components/HtmlEditor.vue';

async function getFqaDictData() {
  const result = await _queryFqaDictDataById(this.fqaDictId, this.fqaDictDataId);
  if (result) {
    this.form.data.code = result.code;
    this.form.data.name = result.name;
    this.form.data.detail = result.detail;
    this.form.data.detailEn = result.detailEn;
    this.form.data.fqaDictId = result.fqaDictId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addFqaDictData(
        this.fqaDictId,
        {
          code: this.form.data.code,
          name: this.form.data.name,
          detail: this.form.data.detail,
          detailEn: this.form.data.detailEn,
        },
      );
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateFqaDictData(
        this.fqaDictId,
        this.fqaDictDataId,
        {
          code: this.form.data.code,
          name: this.form.data.name,
          detail: this.form.data.detail,
          detailEn: this.form.data.detailEn,
        },
      );
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'FqaDictDataEdit',
  components:
    {},
  props: {
    fqaDictId: String,
    fqaDictDataId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    fqaDictDataId() {
      if (this.fqaDictDataId) {
        this.getFqaDictData();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getFqaDictData,
  },
  data() {
    return {
      form: {
        data: {
          code: '',
          name: '',
          detail: '',
          detailEn: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.fqaDictDataId) {
      this.getFqaDictData();
    }
  },
};
</script>
